import { getDropContainerStyleMetrics, isImmediateDropAllowedWidget } from './webDashboardDropGeometry';
import { getRectBounds } from './webDashboardGeometry';

export const getSelectedWidgetIdSet = (selectedWidgetIds = []) => (
	new Set(selectedWidgetIds.map((id) => String(id)))
);

export const getSelectedWidgetRectEntries = ({
	widgets = [],
	selectedIdSet,
	getWidgetRectPx,
	metrics,
}) => (
	widgets
		.filter((widget) => selectedIdSet.has(String(widget.id)))
		.map((widget) => ({
			widget,
			rect: getWidgetRectPx(widget, metrics),
		}))
);

export const getSelectedGroupMoveMetrics = ({
	divertedElement,
	metrics,
}) => {
	const divertedRect = divertedElement.getBoundingClientRect();
	const {
		padLeft,
		padRight,
		padTop,
		padBottom,
		effectiveDropWidth,
		effectiveDropHeight,
	} = getDropContainerStyleMetrics({
		divertedElement,
		divertedRect,
		metrics,
	});

	return {
		padLeft,
		padRight,
		padTop,
		padBottom,
		effectiveWidth: effectiveDropWidth,
		effectiveHeight: effectiveDropHeight,
	};
};

export const getClampedSelectedGroupDelta = ({
	deltaX,
	deltaY,
	bounds,
	padLeft,
	padRight,
	padTop,
	padBottom,
	effectiveWidth,
	effectiveHeight,
}) => {
	const minX = padLeft - bounds.left;
	const maxX = (effectiveWidth - padRight) - (bounds.left + bounds.width);
	const minY = padTop - bounds.top;
	const maxY = (effectiveHeight - padBottom) - (bounds.top + bounds.height);

	return {
		x: Math.max(minX, Math.min(deltaX, maxX)),
		y: Math.max(minY, Math.min(deltaY, maxY)),
	};
};

export const getSelectedGroupMovedRects = ({
	selectedRects,
	selectedIdSet,
	currentWidgets,
	deltaX,
	deltaY,
	padLeft,
	padRight,
	padTop,
	padBottom,
	effectiveWidth,
	effectiveHeight,
	constrainRectToBackgroundImage,
	checkOverlap,
}) => {
	const unselectedWidgets = currentWidgets.filter((widget) => !selectedIdSet.has(String(widget.id)));
	const movedRectsById = new Map();
	let hasConflict = false;

	selectedRects.forEach(({ widget, rect }) => {
		if (hasConflict) return;

		const movedRect = {
			left: rect.left + deltaX,
			top: rect.top + deltaY,
			width: rect.width,
			height: rect.height,
		};

		if (
			movedRect.left < padLeft ||
			movedRect.top < padTop ||
			movedRect.left + movedRect.width > effectiveWidth - padRight ||
			movedRect.top + movedRect.height > effectiveHeight - padBottom
		) {
			hasConflict = true;
			return;
		}

		const constrainedRect = constrainRectToBackgroundImage(
			movedRect.left,
			movedRect.top,
			movedRect.width,
			movedRect.height,
			currentWidgets,
			widget.id,
		);

		if (
			constrainedRect.constrained &&
			(
				Math.abs(constrainedRect.left - movedRect.left) > 0.5 ||
				Math.abs(constrainedRect.top - movedRect.top) > 0.5
			)
		) {
			hasConflict = true;
			return;
		}

		if (
			!isImmediateDropAllowedWidget(widget.type) &&
			checkOverlap(
				movedRect.left,
				movedRect.top,
				movedRect.width,
				movedRect.height,
				unselectedWidgets,
				null,
				widget,
			)
		) {
			hasConflict = true;
			return;
		}

		movedRectsById.set(String(widget.id), movedRect);
	});

	return {
		hasConflict,
		movedRectsById,
	};
};

export const getSelectedGroupBounds = (selectedRects) => (
	getRectBounds(selectedRects.map((entry) => entry.rect))
);
